import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import StyledModal from './StyledModal';

const CsvDownloadModal = ({ title, csvData, trackDownload, close }) => {
  const clickTargetRef = useRef();
  useEffect(() => {
    if (clickTargetRef.current) {
      clickTargetRef.current.click();
    }
  }, [clickTargetRef.current]);

  const {
    url: downloadUrl,
    code: questionCode,
  } = csvData;

  return (
    <StyledModal closeMethod={close} className="download-notification">
      <div>{title}</div>
      <div>
        <p>Your download is ready and will start shortly. If it doesn&apos;t start automatically, <DownloadLink innerRef={clickTargetRef} href={downloadUrl} download={`${questionCode}.csv`} onClick={trackDownload}>click here to download manually</DownloadLink>.</p>
      </div>
    </StyledModal>
  );
};

const DownloadLink = styled.a`
  padding: 0;
`;

CsvDownloadModal.propTypes = {
  title: PropTypes.string,
  csvData: PropTypes.shape({
    url: PropTypes.string,
    code: PropTypes.string,
  }),
  trackDownload: PropTypes.func,
  close: PropTypes.func,
};

export default CsvDownloadModal;



// WEBPACK FOOTER //
// ./app/components/DownloadNotifications/CsvDownloadModal.js